import { patch } from "@/shared/axios";
import useBranchId from "@/shared/hooks/useBranchId";
import { useMutation } from "@tanstack/react-query";

const useUpdateOrderSessionPrintedTime = () => {
  const branchId = useBranchId();
  const mutation = useMutation({
    mutationFn: ({
      orderSessionId,
      dateTime,
    }: {
      orderSessionId: number;
      dateTime: string;
    }) =>
      patch(
        `internal/secure/pos/v1/order/sessions/printed/time/${branchId}/${orderSessionId}`,
        { date_time: dateTime }
      ),
  });

  return mutation;
};

export default useUpdateOrderSessionPrintedTime;
